module.exports = __webpack_public_path__ + "static/media/n29.11e7f8c6.jpg";